import React from 'react';

export const DCLogo = () => {
	return <svg id="DCLogo" data-name="Danger Code" xmlns="http://www.w3.org/2000/svg"
viewBox="0 0 500 140">
    <path d="M318.8,5.18a1.18,1.18,0,0,0,.12-.53,1.21,1.21,0,0,0-1.21-1.21,1.23,1.23,0,0,0-.95.46h0l0,.06,0,0L282.51,51.72h0a1.21,1.21,0,0,0,1,1.93l13.21,0L278.81,88.79h0a1,1,0,0,0-.1.42,1.17,1.17,0,0,0,1.21,1.16h12.83l-16.89,44.55a1.28,1.28,0,0,0-.1.55,1.22,1.22,0,0,0,1.26,1.18,1.26,1.26,0,0,0,1.06-.65l32.68-52.65h0a1.17,1.17,0,0,0,.22-.73,1.22,1.22,0,0,0-1.27-1.16H297.64l17-34.27h0a1.26,1.26,0,0,0,.11-.51,1.21,1.21,0,0,0-1.21-1.21H301.29L318.8,5.18Z"
    fill="#243a6a" />
    <path d="M41.39,74.6c0,13.23-9.79,21.74-21.75,21.74H0V52.86H19.64C31.6,52.86,41.39,61.38,41.39,74.6Zm-15.64,0c0-4.07-2.16-8.33-7.25-8.33H15.26V82.93H18.5C23.78,82.93,25.75,78.42,25.75,74.6Z"
    fill="#bf381c" />
    <path d="M73.36,52.86,87.6,96.34H71.39l-1.27-4.25H56.7l-1.33,4.25H39.28L53.53,52.86ZM60.71,79h5.34l-2.67-8.71Z"
    fill="#bf381c" />
    <path d="M131.27,52.86V96.34h-15.7l-9.16-16.08V96.34H90.65V53h.06l-.06-.13h15.83l9.09,16v-16Z"
    fill="#bf381c" />
    <path d="M180.22,76.45a23,23,0,0,1-45.84-1.85,22.51,22.51,0,0,1,23-22.95c11.95,0,21.43,8.33,22.76,20.16H164.33c-1-3.76-3.63-5.92-7-5.92-4.07,0-7.31,3.31-7.31,8.78,0,4.89,3.12,8.64,7.31,8.64a7,7,0,0,0,3.44-1l-4-5.91Z"
    fill="#bf381c" />
    <path d="M220.2,52.86V66.21H199v2.16H212.7V80.9H199V83H220.2V96.34h-37V52.86Z"
    fill="#bf381c" />
    <path d="M243.66,87.64H240.1v8.7H224.33V52.86h24A17.4,17.4,0,0,1,258.73,84.2l8.51,12.14H250.33ZM240.1,74.48h4.58a4.2,4.2,0,0,0,0-8.4H240.1Z"
    fill="#bf381c" />
    <path d="M367.87,77.34A23,23,0,0,1,322,74.6,23,23,0,0,1,367.87,72H352c-.89-3.88-3.56-6.11-7-6.11-4.07,0-7.37,3.31-7.37,8.78,0,4.89,3.18,8.64,7.37,8.64,3.44,0,6-2.41,7-6Z"
    fill="#e8e2d5" />
    <path d="M415.54,74.6a23,23,0,1,1-45.9,0,23,23,0,0,1,45.9,0Zm-15.64.07c0-5.47-3.24-8.78-7.31-8.78s-7.31,3.31-7.31,8.78c0,4.89,3.12,8.64,7.31,8.64S399.9,79.56,399.9,74.67Z"
    fill="#e8e2d5" />
    <path d="M459.91,74.6c0,13.23-9.79,21.74-21.74,21.74H418.53V52.86h19.64C450.12,52.86,459.91,61.38,459.91,74.6Zm-15.64,0c0-4.07-2.16-8.33-7.24-8.33h-3.24V82.93H437C442.3,82.93,444.27,78.42,444.27,74.6Z"
    fill="#e8e2d5" />
    <path d="M500.22,52.86V66.21H479v2.16h13.73V80.9H479V83h21.24V96.34h-37V52.86Z"
    fill="#e8e2d5" />
</svg>
};



// WEBPACK FOOTER //
// ./src/DCLogo.js